// The legacy analysis key is ticker + direction + entry type, not ticker alone.
// Drupal can serialize its numeric fields as either numbers or strings.
export function isSameEntry(stock, selected) {
  if (!stock || !selected || !stock.ticker || !selected.ticker) return false;
  const value = field => field == null ? '' : String(field);
  return stock.ticker === selected.ticker
    && value(stock.direccio) === value(selected.direccio)
    && value(stock.tipus_entrada) === value(selected.tipus_entrada);
}
